import { SidePanelStructure } from 'components/secondaryMarket/shared/SidePanel/SidePanelStructure';
import styled from 'styled-components';

import { InitialQuoteSidePanel } from './quote/InitialQuote';
import { ConnectedQuotedSidePanel } from './quoted/Quoted';
import { ConnectedQuoteErrorSidePanel } from './quoteError/QuoteError';
import { QuotingSidePanel } from './quoting/Quoting';
import type { SidePanelProps } from './SidePanel.connect';
import { connectSidePanel } from './SidePanel.connect';
import { ConnectedTradedSidePanel } from './traded/Traded';
import { ConnectedTradingSidePanel } from './trading/Trading';

export const StyledDiv = styled.div`
  flex-basis: 40em;
`;

export function RTSidePanel({ tabId, status }: SidePanelProps) {
  return (
    <SidePanelStructure>
      {(status === 'NOT_READY' || status === 'READY') && (
        <InitialQuoteSidePanel tabId={tabId} isReady={status === 'READY'} />
      )}
      {status === 'QUOTING' && <QuotingSidePanel tabId={tabId} />}
      {status === 'QUOTED' && <ConnectedQuotedSidePanel tabId={tabId} />}
      {status === 'TRADED' && <ConnectedTradedSidePanel tabId={tabId} />}
      {status === 'TRADING' && <ConnectedTradingSidePanel tabId={tabId} />}
      {(status === 'QUOTE_FAILED' ||
        status === 'QUOTE_REJECTED' ||
        status === 'TRADE_FAILED' ||
        status === 'TRADE_REJECTED') && <ConnectedQuoteErrorSidePanel tabId={tabId} />}
    </SidePanelStructure>
  );
}

RTSidePanel.displayName = 'QuoteRealtimeFormSidePanel';
export const QuoteRealtimeFormSidePanel = connectSidePanel(RTSidePanel);

QuoteRealtimeFormSidePanel.displayName = 'ConnectedQuoteRealtimeFormSidePanel';
